import { render, staticRenderFns } from "./sizechart.vue?vue&type=template&id=7fc27550&scoped=true&"
import script from "./sizechart.vue?vue&type=script&lang=js&"
export * from "./sizechart.vue?vue&type=script&lang=js&"
import style0 from "./sizechart.vue?vue&type=style&index=0&id=7fc27550&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc27550",
  null
  
)

export default component.exports